// Central site configuration. You can override baseUrl using VITE_SITE_URL in .env
export const SITE = {
  baseUrl:
    (import.meta.env.VITE_SITE_URL as string) || 'https://fernandoaoborges.xyz',
  paths: {
    home: '/',
    projects: '/projects',
    libraries: '/libraries',
    about: '/about',
  },
  // SEO and assets defaults
  seo: {
    defaultImage: '/og-image.png',
    defaultKeywords: 'Portfolio, React Native, Mobile Apps, Developer',
    titleSuffix: 'Fernando A.O.Borges',
    author: 'Fernando A.O.Borges',
    locale: 'pt_BR',
    type: 'website',
    twitterCard: 'summary_large_image',
    robots: 'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
    googlebot: 'index, follow',
    googleSiteVerification: '4djFByNtfWv5VkVpb8EqfC3SdD4eFFX3-vgMMBuVYYM',
    favicon: '/favicon.ico',
    appleTouchIcon: '/apple-touch-icon.png',
    pages: {
      home: {
        title: 'Fernando A.O.Borges | Desenvolvedor React Native',
        description: 'Desenvolvedor React Native com 8 anos de experiência em apps escaláveis e de alta performance. Veja meus projetos, portfolio e bibliotecas open-source.',
        keywords: 'React Native, Desenvolvedor, Apps Mobile, TypeScript, Firebase, iOS, Android, Portfólio',
      },
      projects: {
        title: 'Projetos',
        description: 'Confira os aplicativos e projetos móveis que desenvolvi usando React Native, TypeScript, Firebase e outras tecnologias modernas.',
        keywords: 'Projetos, React Native, Apps Mobile, Portfolio, Desenvolvedor',
      },
      libraries: {
        title: 'Bibliotecas Open Source',
        description: 'Conheça as bibliotecas open-source desenvolvidas por Fernando A.O.Borges. Componentes React, SDKs de autenticação, hooks customizados e muito mais.',
        keywords: 'Bibliotecas, Open Source, React, NPM, GitHub, Código Aberto',
      },
      about: {
        title: 'Sobre Mim',
        description: 'Conheça Fernando A.O.Borges, desenvolvedor React Native com 8+ anos de experiência em aplicativos mobile escaláveis e de alta performance.',
        keywords: 'Sobre, Desenvolvedor, React Native, Experiência, Skills, Tecnologias',
      },
    },
  },
  analytics: {
    enabled: (import.meta.env.VITE_GTAG_ENABLED as string) === 'true' || false,
    gtagId: (import.meta.env.VITE_GTAG_ID as string) || 'AW-863121725',
    conversionId:
      (import.meta.env.VITE_GTAG_CONVERSION as string) ||
      'AW-863121725/BReLCKiqpNAbEL3iyJsD',
    sendConversionOnView: true, // Fire conversion event automatically on page view
  },
  // Social links and organization info
  social: {
    github: 'https://github.com/FernandoAOborges',
    linkedin: 'https://linkedin.com/in/fernandoAOborges',
  },
  organization: {
    name: 'Fernando A.O.Borges',
    logo: '/logo.png',
    description: 'Portfólio de desenvolvedor React Native',
  },
  url(path: string) {
    if (!path) return this.baseUrl
    // ensure path starts with '/'
    const p = path.startsWith('/') ? path : `/${path}`
    return `${this.baseUrl}${p}`
  },
}

export default SITE
